interface Props {
  value: number | null | undefined;
  onValueChange: (v: number | null) => void;
  // Moneda: opcional. Si `showCurrency` es false (precio sin campo de moneda en
  // el schema, p.ej. menú/servicios) se oculta el selector y queda solo «$ monto».
  currency?: string;
  options?: string[]; // opciones servidas por el schema del campo (default MXN/USD)
  onCurrencyChange?: (c: string) => void;
  showCurrency?: boolean; // default true
  placeholder?: string;
}

export default function CurrencyInput({
  value,
  currency,
  options,
  onValueChange,
  onCurrencyChange,
  showCurrency = true,
  placeholder = '0',
}: Props) {
  const opts = options && options.length ? options : ['MXN', 'USD'];
  function toDisplay(n: number | null | undefined): string {
    if (n == null) return '';
    return n.toLocaleString('es-MX');
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value.replace(/[^0-9]/g, '');
    onValueChange(raw === '' ? null : Number(raw));
  }

  // Format the cursor-friendly display: strip commas while focused is handled
  // by showing toDisplay only on the uncontrolled side — we keep it simple:
  // always show formatted, browser doesn't move cursor since we replace non-digits.
  const displayed = toDisplay(value);

  return (
    <div className="flex items-center bg-ui-bg border border-ui-border rounded focus-within:border-ui-accent transition-colors">
      <span className="pl-3 pr-1 text-ui-text-subtle text-sm select-none">$</span>
      <input
        type="text"
        inputMode="numeric"
        value={displayed}
        onChange={handleChange}
        placeholder={placeholder}
        className="flex-1 bg-transparent py-2 px-1 text-sm text-ui-text focus:outline-none placeholder:text-ui-text-subtle min-w-0"
      />
      {showCurrency && (
        <select
          value={currency ?? ''}
          onChange={(e) => onCurrencyChange?.(e.target.value)}
          className="bg-transparent border-l border-ui-border px-2 py-2 text-xs text-ui-text-muted focus:outline-none cursor-pointer hover:text-ui-text transition-colors"
        >
          {!currency && <option value="">—</option>}
          {opts.map((o) => (
            <option key={o} value={o}>{o}</option>
          ))}
        </select>
      )}
    </div>
  );
}
